import { OnBoardingFormValues } from "@/components/elements/UserOnBoarding/types";
import { api } from "@/lib/api-client";

import type { User, UserAddress, UserRequest } from "@/types/user";
import type { UpdateContactsInput } from "./update-contacts";
import type { UpdatePersonalInfoInput } from "./update-personal-info";

export function createUserRequestFromPersonalInfo(user?: User) {
  return (data: UpdatePersonalInfoInput): UserRequest => {
    return {
      ...user,
      additional_info: {
        ...user?.additional_info,
        title: data.title ?? user?.additional_info.title,
        first_name: data.first_name ?? user?.additional_info.first_name,
        last_name: data.last_name ?? user?.additional_info.last_name,
        gender: data.gender ?? user?.additional_info?.gender,
        date_of_birth: data.date_of_birth ?? user?.additional_info.date_of_birth,
        place_of_birth: data.place_of_birth ?? user?.additional_info?.place_of_birth,
        citizenship: data.citizenship ?? user?.additional_info?.citizenship,
      },
    };
  };
}

export function createUserRequestFromContacts(user?: User) {
  return (data: UpdateContactsInput): UserRequest => {
    return {
      ...user,
      email: data.email ?? user?.email,
      additional_info: {
        ...user?.additional_info,
        phone_number: data.phone_number ?? user?.additional_info?.phone_number,
      },
    };
  };
}

export function createUserRequestFromAddress(user?: User) {
  return (data: UserAddress): UserRequest => {
    const addresses = user?.additional_info?.addresses || [];
    return {
      ...user,
      additional_info: {
        ...user?.additional_info,
        addresses: [...addresses, data],
      },
    };
  };
}

export function createUserRequestFromOnBoarding(user?: UserRequest) {
  return (data: OnBoardingFormValues): UserRequest => {
    return {
      ...user,
      additional_info: {
        ...user?.additional_info,
        onboarding: {
          ...user?.additional_info?.onboarding,
          ...data,
        },
      },
    };
  };
}

export const updateUser = (data: UserRequest): Promise<User> => {
  return api.patch("/users/me/", data) as Promise<User>;
};

export function createUserRequestRemovingAddress(user?: User) {
  return (index: number): UserRequest => {
    const addresses = user?.additional_info?.addresses || [];
    return {
      ...user,
      additional_info: {
        ...user?.additional_info,
        addresses: addresses.filter((_, i) => i !== index),
      },
    };
  };
}
